import React, {useEffect, useState} from "react";
import Header from "./main/Header";
import SwiperBanner from "./components/SwiperBanner";
import '../css/Home.css'
import Item from "./components/Item";
import data from '../assets/ItemTest.json'
import firebase from "firebase";
import {useDispatch, useSelector} from "react-redux";
import {AddCart} from "./reducer";
import Contents from "./Contents";
const Home =()=>{
    const db = firebase.firestore();
    const dispatch = useDispatch();
    const [cartItem,setCartItem]=useState([]);
    const [itemList,setItemList]=useState([]);
    let item =useSelector(state => state.add_cart)
    useEffect(()=>{
        if(item){
            setCartItem(item)
        }
    },[])
    useEffect(()=>{
        dispatch(AddCart(cartItem))
    },[cartItem])
    useEffect(()=>{
        db.collection('product').get().then((res)=>{
            let arr = []
            res.forEach((doc)=>{
                let data = doc.data();
                arr.push(data)

            })
            setItemList(arr)
        })

    },[])
    return(
        <>
            <div className={'banner-container'}>
                <img src={process.env.PUBLIC_URL +'/img/bg.jpg'} alt={''} width={"100%"}/>
            </div>
            <Contents/>
        </>
    );
}

export default Home;
